'use strict';

// TODO 還沒定義模組的控管機制，所以直接寫死在這邊。驗證只要改這邊，相關的功能就會自動對應好。
const PAID_MODULES = ['M0', 'M2', 'M1', 'M5', 'M4', 'M3']; // 'M6' 已停用 AI專區
const _MENU = {
	M0: {
		name: ['首頁', 'Home', '首页'],
		ico: 'home-alt',
		url: '/',
	},
	M2: {
		name: ['公共事務區管理', 'Public Affairs Management', '公共事务区管理'],
		shortName: ['公共事務', 'Public Affairs', '公共事务'],
		ico: 'archive',
		children: {
			// M210010: {
			// 	name: ['會議室預約', 'Meeting Room APPT.', '会议室预约'],
			// 	url: '/m210010',
			// },
			// M210030: {
			// 	name: ['通訊錄 / 業務窗口查詢', 'Contact Info. / Contact Person Search', '通讯录 / 业务窗口查询'],
			// 	url: '/m210030',
			// },
			M210021: {
				name: ['組織圖', 'Organizational Chart', '组织结构'],
				url: '/m210021',
				/*
				children: {
					M210021: { name: ['類別1', 'Category 1', '类别1'], url: '/m210021' },
					M210022: { name: ['類別2', ''Category 2', '类别2'], url: '/m210022' },
					M210023: { name: ['類別3', 'Category 3', '类别3'], url: '/m210023' },
					M210024: { name: ['類別4', 'Category 4', '类别4'], url: '/m210024' },
					M210025: { name: ['類別5', 'Category 5', 类别5'], url: '/m210025' },
				},
				*/
			},
			// M210040: {
			// 	name: ['業務窗口維護', 'Contact Person Setting, '业务窗口维护'],
			// 	url: '/m210040',
			// },
		},
	},
	M1: {
		name: ['公告', 'Announcement', '公告'],
		shortName: ['公告', 'Announcement', '公告'],
		ico: 'bullhorn',
		children: {
			M110010: {
				name: ['公告訊息', 'Announcement Message', '公告讯息'],
				url: '/m110010',
			},
			M11002: {
				name: ['頁面管理 / 設定', 'Page Management/Settings', '页面管理/设定'],
				children: {
					M110020: { name: ['頁面管理', 'Page Management', '页面管理'], url: '/m110020' },
					M110040: { name: ['常用名單', 'List of Favorites', '常用名单'], url: '/m110040' },

				},
			},
			M110030: {
				name: ['公告分類維護', 'Announcement Classification and Maintenance', '公告分类维护'],
				url: '/m110030',
			},
		},
	},
	M5: {
		name: ['表單作業', 'Form Operations', '表单作业'],
		shortName: ['表單', 'Form', '表单'],
		ico: 'list',
		children: {
			M510010: {
				name: ['表單申請', 'Form Submission', '表单申请'],
				url: '/m510010',
			},
			M51003: {
				name: ['表單簽核', 'Form Approval', '表单签核'],
				children: {
					M510030: {
						name: ['您未簽核', 'You have not approved', '您未签核'],
						url: '/m510030',
					},
					M510031: {
						name: ['您已簽核', 'You have approved', '您已签核'],
						url: '/m510031',
					},
				},
			},
			M510060: {
				name: ['表單通知', 'Form Notification', '表单通知'],
				url: '/m510060',
			},
			M510020: {
				name: ['表單追蹤', 'Form Tracking', '表单追踪'],
				url: '/m510020',
			},
			M510050: {
				name: ['表單處理', 'Form Processing', '表单处理'],
				url: '/m510050',
			},
			M510040: {
				name: ['簽核代理人設定', 'Substitute Approver Setting', '签核代理人设定'],
				url: '/m510040',
			},
		},
	},
	M4: {
		name: ['個人專區', 'Personal Zone', '个人专区'],
		shortName: ['個人', 'Personal', '个人'],
		ico: 'user-circle',
		children: {
			M4100: {
				name: ['出 / 假勤資料查詢', 'Attendance/Leave Data Search', '出/假勤数据查询'],
				children: {
					M410040: {
						name: ['打卡', 'Clock-in/out', '打卡'],
						url: '/m410040',
					},
					M410050: {
						name: ['加班', 'Overtime', '加班'],
						url: '/m410050',
					},
					M410060: {
						name: ['假勤紀錄', 'Leave Records', '假勤纪录'],
						url: '/m410060',
					},
					M410070: {
						name: ['假勤統計', 'Leave Statistics', '假勤统计'],
						url: '/m410070',
					},
					M410080: {
						name: ['出勤時數紀錄', 'Attendance Hour Records', '出勤时数纪录'],
						url: '/m410080',
					},
					M410081: {
						name: ['每月出勤紀錄確認', 'Monthly Attendance Records Confirmation', '每月出勤记录确认'],
						url: '/m410081',
					},
				},
			},
			M410020: {
				name: ['薪資袋', 'Payroll', '薪资袋'],
				url: '/m410020',
			},
			// M410090: {
			// 	name: ['個人憑證', 'Personal Certificate', '个人凭证'],
			// 	url: '/m410090',
			// },
			// M410010: {
			// 	name: ['打卡月曆', 'Clock-in/out Calendar', '打卡月历'],
			// 	url: '/m410010',
			// },
			M410030: {
				name: ['扣繳憑單查詢', 'Tax Withholding Form Search', '扣缴凭单查询'],
				url: '/m410030',
			},
			M410090: {
				name: ['保費明細查詢', 'Insurance Premium Proof Search', '保费明细查询'],
				url: '/m410090',
			},
			M410: {
				name: ['個人資料查詢', 'Profile Search', '个人资料查询'],
				shortName: ['個人資料', 'Profile', '个人资料'],
				children: {
					M410100: {
						name: ['基本資訊', 'Profile', '基本信息'],
						url: '/m410100',
					},
					M410110: {
						name: ['親屬名單', 'List of Family Members', '亲属名单'],
						url: '/m410110',
					},
					M410120: {
						name: ['帳號安全', 'Account Security', '账号安全'],
						url: '/m410120',
					},
					M410121: {
						name: ['通勤方式調查', 'Commute Survey', '通勤方式调查'],
						url: '/m410121',
					}
				},
			},
			M410130: {
				name: ['學習紀錄查詢', 'Learning Records Search', '学习纪录查询'],
				url: '/m410130',
			},
			M410140: {
				name: ['績效紀錄查詢', 'Performance Records Search', '绩效纪录查询'],
				url: '/m410140',
			},
			M4102: {
				name: ['排班', 'Shift Scheduling', '排班'],
				shortName: ['排班', 'Shift Scheduling', '排班'],
				children: {
					M410200: {
						name: ['班表查詢', 'Shift Schedule Search', '班表查询'],
						url: '/m410200',
					},
					M410210: {
						name: ['預排班表', 'Shift Pre-scheduling', '预排班表'],
						url: '/m410210',
					},
					ZZ_GOODLIVER_M410220: {
						name: [
							'(客製)每月個人出勤表', '(Customize)Personal Duty Monthly', '(客制)每月个人出勤表',
						],
						url: '/zz_goodliver_m410220',
						hint: [],
					},
					M410220: {
						name: ['每月個人出勤表', 'Personal Duty Monthly', '每月个人出勤表'],
						url: '/m410220',
						hint: [],
					},
				},
			},
			M410300: {
				name: ['育嬰留停紀錄查詢', 'Parental Leave Records Search', '育婴留停纪录查询'],
				url: '/m410300',
			},
			ZZ_104_HRMALL: {
				name: ['104 學習中心', '104 學習中心', '104 学习中心'],
				cloudService: 'HRMALL',
			},
			ZZ_104_PERF: {
				name: ['104 績效管理', '104 績效管理', '104 績效管理'],
				cloudService: 'PERF',
			},
			ZZ_104_ATSP: {
				name: ['104 招募管理Pro', '104 eRecruitor Pro', '104 招募管理Pro'],
				cloudService: 'F0135',
			}
		},
	},
	M3: {
		name: ['主管專區', 'Executive Zone', '主管专区'],
		shortName: ['主管', 'Executive', '主管'],
		ico: 'star',
		children: {
			M3100: {
				name: ['部屬出 / 假勤資料查詢', 'Subordinate Attendance/Leave Data Search', '部属出/假勤数据查询'],
				children: {
					M310040: {
						name: ['打卡', 'Clock-in/out', '打卡'],
						url: '/m310040',
					},
					M310050: {
						name: ['加班', 'Overtime', '加班'],
						url: '/m310050',
					},
					M310060: {
						name: ['假勤紀錄', 'Leave Records', '假勤纪录'],
						url: '/m310060',
					},
					M310070: {
						name: ['假勤統計', 'Leave Statistics', '假勤统计'],
						url: '/m310070',
					},
					M310080: {
						name: ['出勤時數紀錄', 'Attendance Hour Records', '出勤时数纪录'],
						url: '/m310080',
					},
				},
			},
			M3101: {
				name: ['部屬個人資料查詢', 'Subordinate Profile Search', '部属个人资料查询'],
				children: {
					M310110: { name: ['基本資料', 'Profile', '基本信息'], url: '/m310110'},
					M310120: { name: ['薪資資料', 'Salary Data', '薪资资料'], url: '/m310110'},
				},
			},
			M310240: {
				name: ['部屬學習紀錄查詢', 'Subordinate Learning Records Search', '部属学习纪录查询'],
				url: '/m310240',
			},
			M310250: {
				name: ['部屬績效紀錄查詢', 'Subordinate Performance Records Search', '部属绩效纪录查询'],
				url: '/m310250',
			},
			M3102: {
				name: ['部屬班表查詢', `Subordinate Shift Schedule Search`, '部属班表查询'],
				children: {
					M310210: {
						name: ['員工班表', `Staff Shift Schedule`, '员工班表'],
						url: '/m310210',
					},
					M310220: {
						name: ['班別人力統計', 'Manpower Statistics by Shift', '班别人力统计'],
						url: '/m310220',
					},
					M310230: {
						name: ['時段人力統計', 'Manpower Statistics by Period', '时段人力统计'],
						url: '/m310230',
					},
				},
			},
			M310: {
				name: ['排班管理', 'Shift Management', '排班管理'],
				shortName: ['排班管理', 'Shift Management', '排班管理'],
				children: {
					M310410: {
						name: ['班表管理', 'Shift Schedule Management', '班表管理'],
						url: '/m310410',
					},
					M310420: {
						name: ['AI排班', 'AI Shift Scheduling', 'AI排班'],
						url: '/m310420',
						hidden: 1,
					},
					M310320: {
						name: ['人力配置', 'Resource Allocation', '人力配置'],
						url: '/m310320',
					},
					M310310: {
						name: ['排班設定', 'Shift Setting', '排班设定'],
						url: '/m310310',
					},
					ZZ_STARLIKE_M310610:{
						hide: 1,
						name: ['支援排班班表設定', 'Support Shift Setting', '支援排班班表设定'],
						url: '/zz_starlike_m310610',
						hint: [],
					},
				},
			},
			M3105: {
				name: ['儀表板', 'Dashboard', '仪表板'],
				shortName: ['儀表板', 'Dashboard', '仪表板'],
				children: {
					M310510: {
						name: ['性別統計', 'Gender statistics', '性别统计'],
						url: '/m310510',
					},
					M310520: {
						name: ['年齡統計', 'Age statistics', '年龄统计'],
						url: '/m310520',
					},
					M310530: {
						name: ['離職統計', 'Turnover statistics', '离职统计'],
						url: '/m310530',
					},
					M310540: {
						name: [
							'育嬰留停復職統計',
							'Parental leave and return-to-work statistics',
							'育婴留停复职统计',
						],
						url: '/m310540',
					},
					M310550: {
						name: [
							'公傷病假統計',
							'Work-related injury and sickness absence statistics',
							'公伤病假统计',
						],
						url: '/m310550',
					},
					M310560: {
						name: [
							'產假/產檢假/陪產假統計',
							'Maternity leave/maternity examination leave/paternity leave statistics',
							'产假/产检假/陪产假统计',
						],
						url: '/m310560',
					},
					M310580: {
						name: ['薪資結構統計', 'Salary structure statistics', '薪资结构统计'],
						url: '/m310580',
					},
				},
			},
			M310600: {
				name: ['部屬育嬰留停紀錄查詢', 'Subordinate Parental Leave Records Search', '部属育婴留停纪录查询'],
				url: '/m310600',
			}
		},
	},
	// M6: {
	// 	name: ['AI專區', 'AI Zone', 'AI专区'],
	// 	shortName: ['AI專區', 'AI Zone', 'AI专区'],
	// 	ico: '',
	// 	children: {
	// 		M610110: {
	// 			name: ['AI小夥伴', 'AI Buddies', 'AI小伙伴'],
	// 			url: '/',
	// 		},
	// 	},
	// },
};

let paidMenu = PAID_MODULES.reduce((acc, module) => {
	acc[module] = _MENU[module];
	return acc;
}, {});

let customize;
const sno = (typeof window === 'undefined') ? process.env.SNO : window.sno;
if (sno) {
	try {
		customize = require(`../customize/${sno}/constants/menu-portal`);
	} catch (err) {
	}
}

module.exports = Object.freeze({
	MENU: customize ? customize(paidMenu) : paidMenu,
});
